import { render } from "./OnboardingTour.vue?vue&type=template&id=1da3c7e8&scoped=true"
import script from "./OnboardingTour.vue?vue&type=script&lang=js"
export * from "./OnboardingTour.vue?vue&type=script&lang=js"

import "./OnboardingTour.vue?vue&type=style&index=0&id=1da3c7e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da3c7e8"]])

export default __exports__